module.exports = __webpack_public_path__ + "static/media/covid-1.9a67cc58.md";